// extracted by mini-css-extract-plugin
module.exports = {"topRightCornerCheckbox":"styles_topRightCornerCheckbox__ZEIIT","sectionDisabled":"styles_sectionDisabled__1iCb0","sectionContainer":"styles_sectionContainer__BhPah"};